export var Cell=function(_props){return null};Cell.displayName="Cell";